import store from '../store';
import { of } from 'rxjs';
import { switchMap, tap, map, mergeMap } from 'rxjs/operators';
import { APP_CONFIG } from '@/config';
import { httpService } from './httpClient.service';
import { wxService } from './wx.service';
import { lsService } from './ls.service';
import { dvService } from './device.service';

/** 关卡序号 */
export enum Shut {
  s1 = 1,
  s2,
  s3,
  s4,
  s5,
}
export interface GameInfo {
  openid: string;
  shut: Shut;
  times: number;
  random_num?: string;
}

/** 本地缓存服务 */
class UserService {
  userData: any = {};

  /** 获取中奖列表 */
  getLuckylist(openid: string) {
    return httpService.post(APP_CONFIG.ep.luckylist, { openid });
  }

  /** 提交预约试驾信息 */
  postTestDrive(data) {
    return httpService.post(APP_CONFIG.ep.postTestDrive, data);
  }

  /** 提交用户信息 */
  postForm({ name, phone, openid }) {
    return httpService.post(APP_CONFIG.ep.postForm, { name, phone, openid });
  }

  /** 获取用户信息，包含游戏数据 */
  getUserInfo(openid: string) {
    return httpService.get(APP_CONFIG.ep.getUserInfo, { openid });
  }

  /** 提交游戏数据 */
  postGameInfo(data: GameInfo) {
    return httpService.post(APP_CONFIG.ep.postGameInfo, data);
  }

  /** 提交参与抽奖 */
  postLottery({ openid, chapter }) {
    return httpService.post(APP_CONFIG.ep.lottery, { openid, chapter });
  }

  /** 提交领奖信息 */
  postPrizeInfo({ openid, newname, newphone, newaddress }) {
    return httpService.post(APP_CONFIG.ep.postPrizeInfo, { openid, newname, newphone, newaddress });
  }

  /** 初始化本地数据 */
  initStoreData() {
    return lsService.getUserData().pipe(
      tap(res => {
        console.log(`localdata`, res);
        if (res) store.dispatch('update', { key: 'allcheck', data: res });
        else lsService.saveUserData(store.state.allcheck);
      }),
    );
  }

  /** 获取服务器用户数据 */
  initUserData(openid: string) {
    openid = openid || '123456789012345678901234567890';
    return this.getUserInfo(openid);
  }

  /** merge服务器数据到store数据 */
  mergeData(res) {
    return of(res).pipe(
      tap(res => {
        console.log('get info res: ', res);
        if (res) {
          const { allcheck, every_chapter_prize_num, info, times, personal_lucky, address } = res.data;
          store.commit('update', { key: 'every_chapter_prize_num', data: every_chapter_prize_num });
          store.commit('update', { key: 'times', data: times * 1000 });
          store.commit('update', { key: 'personal_lucky', data: personal_lucky });
          // store.commit('update', { key: 'personal_lucky', data: [1, 2] });
          store.commit('update', { key: 'address', data: address });

          if (wxService.openId) {
            allcheck.push(store.state.allcheck[5], store.state.allcheck[6], store.state.allcheck[7]);

            // store.state.allcheck = allcheck;
            store.dispatch('update', { key: 'allcheck', data: allcheck });
            store.dispatch('update', { key: 'info', data: Boolean(info) });
          }
        }
        return of(0);
      }),
    );
  }
}

/** 单例对象函数 */
const service = (() => {
  // 隐藏的Class的构造函数
  // function TodayCilpService() {}

  // 未初始化的单例对象
  let service: UserService;

  return {
    // 创建/获取单例对象的函数
    getInstance: () => {
      if (!service) {
        service = new UserService();
      }
      return service;
    },
  };
})();
export const userService = service.getInstance();
